import { apiCallAc } from "..";

export function fetchStickers() {
	return apiCallAc.get(`/dashboard/image/editor/stickers/microsoft`);
}

export function fetchStickersNext(url) {
	return apiCallAc.get(url);
}
